<div class="row online-content-view-centric-row align-items-center">
    <div class="col-1">{{ item.type }}</div>
    <div class="col-2 text-center">{{ item.className }}</div>
    <div class="col-1 text-left">{{ item.classDate | bcDate: 'MMM DD' }}</div>
    <div class="col-1 text-center">{{ item.timeFrom | bcDateTime: 'hh:mm A' }}</div>
    <div class="col-1">{{ item.timeTo | bcDateTime: 'hh:mm A' }}</div>
    <div class="col-2">{{ item.instructorName }}
        <span class="online-content-view-substitution" *ngIf="item.instructorSubstituted">(sub)</span>
    </div>
    <div class="col-1">{{ item.memberId }}</div>
    <div class="col-2 text-right">{{ item.memberName }}</div>
    <div class="col-1 text-center">{{ item.viewDate | bcDateTime: 'MMM DD hh:mm:ss A' }}</div>
</div>
